import React, { useEffect, useState, useRef } from 'react';
import Matter from 'matter-js';

const TheEnd = ({theme}) => {

  const boxRef = useRef(null)

  const [constraints, setContraints] = useState()
  const [scene, setScene] = useState()

  const handleResize = () => {
    setContraints(boxRef.current.getBoundingClientRect())
  }

  useEffect(() => {

    var ww = window.innerWidth;
    var hh = window.innerHeight;
    var ab, balls = 0;
    var total_balls = 80;
    let titleFontSize = 110;
    let rad = (ww<695)?22:39;
    let textColor = (theme) ? theme.pageStyle2.main : '#aaaaaa';
    let shapeColors;
    if (theme) {
      shapeColors = [
        theme.pageStyle2.hint1,
        theme.pageStyle1.hint1,
        theme.pageStyle2.hint2,
        theme.pageStyle1.hint2,
      ];
    } else {
      shapeColors = [
        '#aaaaaa',
        '#f9f9f9'
      ];
    }

    ab = setInterval(dropShape, 180);

    // module aliases
    var Engine = Matter.Engine,
      Render = Matter.Render,
      Runner = Matter.Runner,
      Body = Matter.Body,
      Bodies = Matter.Bodies,
      Common = Matter.Common,
      Events = Matter.Events,
      Composite = Matter.Composite,
      Vertices = Matter.Vertices,
      Svg = Matter.Svg,
      MouseConstraint = Matter.MouseConstraint,
      Mouse = Matter.Mouse;

    // create an engine
    var engine = Engine.create(),
      world = engine.world;;

    // create a renderer
    var render = Render.create({
      element: boxRef.current,
      engine: engine,
      options: {
        width: ww,
        height: hh,
        showAngleIndicator: false,
        wireframes: false,
        background: 'transparent',
      }
    });

    // floor
    Composite.add(world, Bodies.rectangle(render.canvas.width / 2, render.canvas.height-200, render.canvas.width, 90, { isStatic: true, render: { fillStyle: '#215BAD' } }));

    // left wall
    Composite.add(world, Bodies.rectangle(0, render.canvas.height / 2, 10, render.canvas.height, { isStatic: true, render: { fillStyle: '#215BAD' } }));

    // right wall
    Composite.add(world, Bodies.rectangle(render.canvas.width, render.canvas.height / 2, 10, render.canvas.height, { isStatic: true, render: { fillStyle: '#215BAD' } }));

    var mouse = Mouse.create(render.canvas),
      mouseConstraint = MouseConstraint.create(engine, {
        mouse: mouse,
        constraint: {
          stiffness: 0.2,
          angularStiffness: 0, // rotate when grabbed?
          render: {
            visible: false
          }
        }
      });

    Composite.add(world, mouseConstraint);

    // keep the mouse in sync with rendering
    render.mouse = mouse;
    Render.run(render);
    var runner = Runner.create();
    Runner.run(runner, engine);

    let topOfTextArea = (hh - 350) / 2;
    let leftOfTextArea = (ww < 695) ? 110 : (ww - 555) / 2;
    let thankWidth = (ww < 695)?(ww/1.6):483;
    let youWidth = (ww < 695) ? (ww / 2.5) : 287;
    let boxHeight = (ww < 695) ? 60 : 90;

    var textThank = Bodies.rectangle(leftOfTextArea + (thankWidth / 2) - 100, topOfTextArea, thankWidth, boxHeight, {
      isStatic: true,
      render: {
        fillStyle: 'rgba(255,255,255,0)',
        label: 'THANK',
        text: { content: 'THANK', size: titleFontSize }
      }
    })
    var textYou = Bodies.rectangle(leftOfTextArea + (youWidth / 2) + 270, topOfTextArea + 196, youWidth, boxHeight, {
      isStatic: true,
      render: {
        fillStyle: 'rgba(255,255,255,0)',
        label: 'YOU',
        text: { content: 'YOU', size: titleFontSize, color: textColor }
      }
    })

    Composite.add(engine.world, [
      textThank, textYou
    ]);

    Body.rotate(textThank, Math.PI / 40);
    Body.rotate(textYou, Math.PI / -30);

    function dropShape() {
      var rest = 1;
      balls += 1;
      var c = Bodies.polygon(
        Math.random() * (render.canvas.width),
        -40,
        Math.floor(Math.random() * 3 + 3),
        rad,
        { restitution: rest }
      );
      c.render.fillStyle = shapeColors[Math.floor(Math.random() * 5)];
      Composite.add(engine.world, c);
      if (balls > total_balls) {
        clearInterval(ab);
      }
    }

    setContraints(boxRef.current.getBoundingClientRect())
    setScene(render)

    window.addEventListener('resize', handleResize)

  }, [])

  useEffect(() => {
    if (constraints) {
      let { width, height } = constraints

      // Dynamically update canvas and bounds
      scene.bounds.max.x = width
      scene.bounds.max.y = height
      scene.options.width = width
      scene.options.height = height
      scene.canvas.width = width
      scene.canvas.height = height

      // Dynamically update bodies
      const floor = scene.engine.world.bodies[0],
      wallLeft = scene.engine.world.bodies[1],
      wallRight = scene.engine.world.bodies[2],
      thank = scene.engine.world.bodies[3],
      you = scene.engine.world.bodies[4];

      if (width<695) {
        thank.render.text.size = you.render.text.size = width * 0.16;
        Matter.Body.setPosition(you, {
          x: width - 100,
          y: height / 2,
        })
      }

      Matter.Body.setVertices(floor, [
        { x: 0, y: height },
        { x: width, y: height },
        { x: width, y: height + 10 },
        { x: 0, y: height + 10 },
      ])

      Matter.Body.setPosition(floor, {
        x: width / 2,
        y: height + 5,
      })

      Matter.Body.setPosition(wallLeft, {
        x: -5,
        y: height / 2,
      })

      Matter.Body.setPosition(wallRight, {
        x: width + 5,
        y: height / 2,
      })


    }
  }, [scene, constraints])


  return (
    <div className="w-screen min-h-screen pageStyle1" id="splash">
      <div ref={boxRef} className="splash w-screen h-screen absolute top-0 left-0"></div>
    </div>
  );

}

export default TheEnd;
